import type * as React from 'react';

import type * as api from '@gitbook/api-client';

import { BillingInvoicePreview } from './BillingInvoicePreview';

/**
 * Shows a preview of the invoice generated following a site type change or a publish action.
 */
export function SiteBillingInvoicePreview({
    billing,
    invoice,
    details,
}: {
    billing: api.OrganizationBilling;
    invoice: api.BillingInvoicePreview;
    details: React.ReactNode;
}): React.ReactElement {
    return (
        <div className="w-full">
            <div className="mb-1">{details}</div>
            <BillingInvoicePreview
                billingInterval={billing.interval}
                billingPeriodEnd={billing.endDate}
                invoice={invoice}
            />
        </div>
    );
}
